import { render, staticRenderFns } from "./PetSettingPage.vue?vue&type=template&id=c5421956"
import script from "./PetSettingPage.vue?vue&type=script&lang=js"
export * from "./PetSettingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports